"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.addToOrFilterFrom = exports.hasLength = exports.filterStateByIds = exports.isInState = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const curryCallback = (fn, value) => () => fn(value);
const filterByValue = function () {
  let arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let value = arguments.length > 1 ? arguments[1] : undefined;
  return arr.filter(i => i !== value);
};
const isInState = function () {
  let arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return arr.filter(item => ids.includes(item));
};
exports.isInState = isInState;
const filterStateByIds = function () {
  let arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return arr.filter(item => !ids.includes(item));
};
exports.filterStateByIds = filterStateByIds;
const hasLength = arr => Array.isArray(arr) && arr.length > 0;
exports.hasLength = hasLength;
const addToOrFilterFrom = function () {
  let arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let value = arguments.length > 1 ? arguments[1] : undefined;
  return arr.includes(value) ? filterByValue(arr, value) : arr.concat(value);
};
exports.addToOrFilterFrom = addToOrFilterFrom;
const useCheckboxes = () => {
  const [checked, setChecked] = _react.default.useState([]);
  const isNotEmpty = hasLength(checked);
  const clear = curryCallback(setChecked, []);
  const isChecked = _react.default.useCallback(key => checked.includes(key), [checked]);
  const onCheck = key => () => setChecked(prev => addToOrFilterFrom(prev, key));
  const onCheckAll = ids => !isNotEmpty ? curryCallback(setChecked, ids) : clear;
  const onCheckSome = ids => () => setChecked(prev => !hasLength(isInState(prev, ids)) ? [...new Set([...ids, ...prev])] : filterStateByIds(prev, ids));
  const hasChecked = () => _react.default.useCallback(isNotEmpty, [checked]);
  return {
    checked,
    setChecked,
    onCheck,
    onCheckAll,
    onCheckSome,
    isChecked,
    hasChecked,
    hasLength,
    clear
  };
};
var _default = useCheckboxes;
exports.default = _default;